
import Float from "@/js/float";
import querystring from "@/js/querystring";
import bankInfo from "@/components/BankInfo";
import chooseCard from "@/components/ChooseCard";
import topRemind from "@/components/TopRemind";
import {
getStorage,
setStorage,
getAppInfo,
getThemeByType,
isWeixin,
lasterVersion,
isWxMiniProgram,
getCookie,
navigateTo,
getIp,
queryFormat,
getEnv,
getFormData,
setNavigation,
addWhiteList,
BuildVersionDiff,
} from "@/js/utils";
import { SUCCESS_CODE } from "@/service/httpCode";
import sendVertificationCode from "@/components/SendVertificationCode";
import checker from "@/components/Checker";
import debounce from 'vux/src/tools/debounce/index.js'

import preMultiRepay from "@/components/PreMultiRepay";
import editAmountDialog from "@/components/Repay/EditAmountDialog";
import repayDetailDialog from "@/components/Repay/RepayDetailDialog";
import payMethod from "@/components/Repay/PayMethod";
import openGoldenCard from "@/components/Repay/OpenGoldenCard";
import repayInfo from "@/components/Repay/RepayInfo";
import loadFont from "@/js/loadFont";
import guideBindCardDialog from "@/components/Repay/GuideBindCardDialog";
import rejectRepayDialog from "@/components/Repay/RejectRepayDialog";
import CombinedPay from "@/components//Repay/CombinedPay";
import EarlySettleRetentionDialog from "@/components/Repay/EarlySettleRetentionDialog";
import OpenGoldenCardRetentionDialog from "@/components/Repay/OpenGoldenCardRetentionDialog";

const { svipPopup, protocolPopup } = window.web_svip_popup || {};

export default {
name: "repay",
components: {
bankInfo,
chooseCard,
topRemind,
sendVertificationCode,
checker,
preMultiRepay,
editAmountDialog,
repayDetailDialog,
payMethod,
openGoldenCard,
svipPopup,
protocolPopup,
repayInfo,
guideBindCardDialog,
rejectRepayDialog,
CombinedPay,
EarlySettleRetentionDialog,
OpenGoldenCardRetentionDialog
},
data() {
return {
showProtocolPopup: false,
showVipPopup: false,
showPop: false,
isBtnDisabled: false,
isLoading: false,
showAlert: false,
repayInitData: {},
redPacketAmount: "",
isVertificationCodeShow: false,
mobile: "",
bankInfo: {},
themeType: "default",
time: 0,
payMethod: "card",
currentChoosedCard: "",
isOfflineRepayBtnShow: false,
isSupportWechat: false,
isSupportAlipay: false,
showEditAmountDialog: false,
actualAmount: 0,
isPreMultiRepay: false,
preMultiRepay: {},
showRepayDetailDialog: false,
period: 1,
isShowOtherRepay: false,
methods: [],
isChooseGold: "n",
vipVo: null,
svipType: "",
svipTypeName: "",
maxAmount: "",
isEditClick: false,
repayAmount: "",
resultThemeSwitch: false,
isTarsInWX: false,
thirdChannel: "",
aliPayTags: {
zfbActive: false,
zfbActiveContent: "",
},
couponUsed: "",
isWxMiniProgram: false,
wxClientIp: "",
formData: {
action: "",
params: [],
},
smsType: "",
signStatusCode: "",
signStatusMsg: "",
repayPage: 1,
showRepayfmCoupon: true, // 是否展示逾期还款费免优惠券
showBindCardDialog: false,
rejectRepayMessage: "",
showRejectRepayDialog: false,
isZfbFirst: false,
combinedRepayAmount: 0, // 组合支付待还总金额
showCombinedRepay: false,
showEarlySettleRetention: false,
showEarlySettleRetentionDialog: false,
showOpenGoldenCardRetentionDialog: false,
closeCurrentPageType: '', // 离开当前页面类型
isShowVipMemberRetention: false, // 是否展示拍金卡拦截
showRepaydlCoupon: true, // 是否展示导流优惠券金额
};
},
computed: {
payMethods() {
let methods = [];
const paymentMethods = this.repayInitData.paymentMethods;

if (this.isSupportAlipay && this.isAlipayShow) {
methods.push("alipay");
}

if (this.isSupportWechat && this.isWechatPayShow) {
methods.push("wechat");
}

if (
paymentMethods.includes(5) &&
(this.isLoanApp || (this.isKooApp && lasterVersion("4.6.0"))) &&
this.isChooseGold === "n"
) {
methods.push("friendPay");
}

if (paymentMethods.includes(0)) {
methods.push("offlinePay");
}

return methods;
},
hasReward() {
const { maxPeriod, modelTag } = this.preMultiRepay;
return maxPeriod === this.period;
},
isWechatPayShow() {
const paymentMethods = this.repayInitData.paymentMethods;
return (
((this.isLoanApp || this.isKooApp) &&
this.repayInitData &&
paymentMethods &&
paymentMethods.includes(3)) ||
(isWeixin() && paymentMethods && paymentMethods.includes(6)) ||
(this.isWxMiniProgram &&
paymentMethods &&
paymentMethods.includes(8))
);
},
isAlipayShow() {
const paymentMethods = this.repayInitData.paymentMethods;
return paymentMethods.includes(7);
},
isBill() {
return [8, 9].includes(this.repayInitData.orderType);
},

isCMBSigning() {
const bizType = getEnv();
return (
bizType == "Loan" ||
bizType == "LoanMiniprogram" ||
bizType == "LoanWx" ||
bizType == "Koo" ||
bizType == "KooMiniprogram" ||
bizType == "KooWx" ||
bizType == "TTMiniprogram"
);
},
},
watch: {
isChooseGold() {





if (
this.isChooseGold === "n" &&
+this.actualAmount > 50000 &&
this.judgeSupportedPayMethod(0)
) {
this.payMethod = "offlinePay";
}
},
actualAmount() {
const bankList = this.repayInitData.bankCardList || [];


let supportSplitBank = null;
this.bankInfo = bankList.find((item) => {
if (item.isSplit === 1 && (!supportSplitBank || +item.singleLimit > +supportSplitBank.singleLimit)) {
supportSplitBank = item;
}
return item.singleLimit ? +item.singleLimit >= +this.actualAmount : true;
});
if (!this.bankInfo) {
this.bankInfo = supportSplitBank || {};
}

this.currentChoosedCard = this.bankInfo.userBankAccountId;

if (this.isZfbFirst && this.isSupportAlipay && this.isAlipayShow) {
this.payMethod = "alipay";
} else if (this.currentChoosedCard) {
this.payMethod = "card";
} else if (this.isSupportAlipay && this.isAlipayShow) {
this.payMethod = "alipay";
} else if (this.isSupportWechat && this.isWechatPayShow) {
this.payMethod = "wechat";
} else if (
this.judgeSupportedPayMethod(0) &&
(+this.actualAmount > 50000 || !this.currentChoosedCard)
) {
this.payMethod = "offlinePay";
} else {

this.payMethod = "card";
this.bankInfo = bankList[0] || {};
this.currentChoosedCard = this.bankInfo.userBankAccountId;
}
},
},
activated() {
const redEnvelopes = this.repayInitData.redEnvelopes;

if (redEnvelopes && redEnvelopes.length) {
this.getRedPacketAmount();
}

if (this.isShowVipMemberRetention) {
this.openGoldenCardSetNavigation();
}
},
methods: {
popstateFunc() {
window.history.go(-2);
},
viewProtocol() {
this.showProtocolPopup = true;
this.sendRecord("618");
this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_618",
tgt_name: "h5-paycash-确认还款页-拍金卡-点击协议",
param4: this.repayPage,
});
},
viewDetail() {
this.showVipPopup = true;
this.sendRecord("617");
this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_617",
tgt_name: "h5-paycash-确认还款页-拍金卡-查看详情",
param4: this.repayPage,
});
},
preRepay() {
if (this.period === 1) {
this.nextStep();
} else {
this.showRepayDetailDialog = true;
}
},
friendPay() {
this.sendRecord("800");
const {
wxCopywriting,
realName,
offAmount,
expirePartRepay,
upAmount,
repayAmount,
} = this.repayInitData;

let _repayAmount = 0;
if (expirePartRepay && this.actualAmount != upAmount) {

_repayAmount = this.actualAmount;
} else {
_repayAmount = offAmount
? Float.subtract(repayAmount, offAmount, 2)
: repayAmount;
}
this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_800",
tgt_name: "h5-paycash-确认还款页-他人代偿",
param4: upAmount,
param5: repayAmount,
param6: offAmount,
param7: _repayAmount,
});

setStorage("session", "friendPayParams", {
wxCopywriting: wxCopywriting,

repayAmount: _repayAmount,
themeType: this.themeType,
realName: realName,
period: this.period,
});
this.$router.push({
name: "helpToRepay",
query: {
orderNo: this.orderNo,
},
});
},
confirmRepay() {
this.showRepayDetailDialog = false;
this.nextStep();
},
editAmount() {
this.showEditAmountDialog = true;
},
changeAmount(amount) {
const { repaymentType, upAmount } = this.repayInitData;

this.actualAmount = amount;


if ([1, 2].includes(repaymentType)) {
const amountChange = this.actualAmount == upAmount;

this.showRepayfmCoupon = amountChange;
this.showRepaydlCoupon = amountChange;
}


this.repayInitData.bankCardList.forEach((x) => {
if (x.isSplit === 1 && (this.actualAmount <= x.singleLimit)) {
this.$set(x, "isSplit", 0);
} else if (x.isSplit === 0 && x.singleLimit < this.actualAmount) {
this.$set(x, "isSplit", 1);
}
});

if (this.showCombinedRepay) {
this.setCombinedRepayAmount(this.actualAmount);
}
},
stepperChange(amount, period) {
this.changeAmount(amount);
this.period = period;
},
offlineRepay() {
const {
amount,
repaymentType,
upAmount,
offAmount,
vipVo,
offBankVo,
repayfmCouponAmount,
offRandomAmount,
repaydlCouponAmount
} = this.repayInitData;

let offlineAmount =
repaymentType === 3 && !this.isBill
? this.actualAmount
: amount;
let svipOutPrice = vipVo ? vipVo.svipOutPrice : 0;
if (this.isChooseGold === "y") {
offlineAmount = Float.add(offlineAmount, svipOutPrice, 2);
}
setStorage("session", "offBankVo", offBankVo);
this.$router.push({
name: "offlineRepay",
query: {
amount: offlineAmount,
orderNum: this.orderNo,
themeType: this.themeType,
bizCode: this.bizCode,
redPacketCode: this.redPacketCode || "",
multiPeriod: this.period,
offAmount,
vipOpenTag: this.isChooseGold === "y",
repayfmCouponAmount,
offRandomAmount,
repaydlCouponAmount
},
});
},
async addCard() {
this.sendRecord("640");
this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_640",
tgt_name: "h5-paycash-确认还款页-添加新的银行卡(多卡)",
});
const { data, result } = await this.$http.addCard({
orderNum: this.$store.orderNo,
});
if (result === SUCCESS_CODE) {
location.href = data.url;
}
},
goToChooseCard() {
this.showPop = true;
this.sendRecord("630");
this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_630",
tgt_name: "h5-paycash-确认还款页-点击已绑定银行卡(多卡)",
});
},
deleteCard(userBankAccountId) {
this.showPop = false;
const vm = this;
this.$vux.confirm.show({
title: "提示",
content: "确认要删除这张银行卡吗",
onConfirm: async () => {
vm.sensorsRecordRepay({
tgt_event_id: "h5_paycash_repay_delete_card",
tgt_name: "h5-paycash-确认还款页-删除银行卡",
});

const { data } = await vm.$http.unbind({
orderNum: vm.$store.orderNo,
userBankAccountId,
});
if (data) {
location.href = data.url;
} else {
const bankList = this.repayInitData.bankCardList;
const idx = bankList.findIndex(
(item) =>
item.userBankAccountId === userBankAccountId
);
bankList.splice(idx, 1);


if (
this.bankInfo.userBankAccountId ===
userBankAccountId
) {
let supportSplitBank = null;
this.bankInfo = bankList.find((item) => {
if (item.isSplit === 1 && (!supportSplitBank || +item.singleLimit > +supportSplitBank.singleLimit)) {
supportSplitBank = item;
}
return item.singleLimit ? +item.singleLimit >= +this.actualAmount : true;
});
if (!this.bankInfo) {
this.bankInfo = supportSplitBank || {};
}
this.currentChoosedCard =
this.bankInfo.userBankAccountId;
}
}
},
});
},
async changeCard() {
this.sendRecord("650");
this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_650",
tgt_name: "h5-paycash-确认还款页-更换银行卡(单卡)",
});
const { data, result } = await this.$http.changeCard({
orderNum: this.orderNo,
userBankAccountId: this.bankInfo.userBankAccountId,
});
if (result === SUCCESS_CODE) {
location.href = data.url;
}
},
chooseMethod({ type, bankInfo }) {
if (type === "card") {
this.payMethod = type;
this.bankInfo = bankInfo;
this.currentChoosedCard = this.bankInfo.userBankAccountId;
}
if (["wechat", "alipay"].includes(type)) {
this.currentChoosedCard = "";
this.payMethod = type;
}

if (type === "friendPay") {
this.friendPay();
}

if (type === "offlinePay") {
this.offlineRepay();
}

this.showPop = false;
},
async vertificationCodeCallback(codes) {
if (this.isBill) {
const params = {
orderNum: this.orderNo,
smsCode: codes,
smsToken: this.smsToken,
smsType: this.smsType,
};
const { result, data } = await this.$http.billSmsCheck(params);
if (result === SUCCESS_CODE) {
if (data.hasNext) {
this.time++;

this.bankRepayApply();
this.isVertificationCodeShow = false;
return;
}
} else {
this.$bus.$emit("validate-code-error");
return;
}
}

this.verCode = codes;
this.isVertificationCodeShow = false;
this.repayApply();
},
async sendVertificationCode(isResend) {
const params = Object.assign(this.getBasicReqParams(), {
sourceId: this.sourceId,
userBankAccountId: this.bankInfo.userBankAccountId,
paymentMethod: this.paymentMethod,
inputAmount: this.actualAmount,
callbackUrl: this.getSignReturnUrl(),
});

const resp = await this.$http.repayNeedSms(params);
const { result, data } = resp;
if (isResend && result === SUCCESS_CODE) {
this.smsToken = data.smsToken;
}

return resp;
},
getRedPacketAmount() {
const { amount, code, couponUsed } =
getStorage("session", "redPacketInfo") || {};
this.redPacketAmount =
amount > 0 ? parseFloat(amount).toFixed(2) : "";
this.redPacketCode = code || "";
this.couponUsed = couponUsed || "";
},
hidePopup() {
this.showPop = false;
},
getBasicReqParams() {
return {
orderNum: this.orderNo,
redEnvelopeAmount: this.redPacketAmount,
redEnvelopeCode: this.redPacketCode,
repayChargeAmount: this.actualAmount,
};
},
jumpToResultPage() {
const {
failChangeCard,
repayResultPageTag,
repayADUrl,
orderType,
weChatUrl,
multiCard,
processingSeconds,
interestFreeCoupon,
holidayAmount,
vipVo,
upAmount,
billId,
sourceTitle,
lineCode,
repayVipBenefitAmount
} = this.repayInitData;

const { rewardAmount, maxPeriod, modelTag } = this.preMultiRepay;

const isKoo = this.bizCode === "105";

setStorage("session", "repayResultParams", {
isShowChangeCard: failChangeCard,
userBankAccountId: this.bankInfo.userBankAccountId,
isShowResult: repayResultPageTag,
repayADUrl: repayADUrl,
orderType: orderType,
themeType: this.themeType,
weChatUrl,
multiCard,
processingSeconds,
isKoo,
repayAmount: this.actualAmount,
isPreMultiRepay: this.isPreMultiRepay,
rewardAmount,
payMethod: this.payMethod,
resultThemeSwitch: this.resultThemeSwitch,
cashbackInfo: {
interestFreeCoupon,
holidayAmount,
redPacketAmount: this.redPacketAmount,
goldenDiscount:
vipVo && this.isChooseGold === "y"
? vipVo.payBackAmount
: 0,
svipOutPrice: vipVo ? vipVo.svipOutPrice : 0,
benefitAmount: repayVipBenefitAmount
},
billId,
sourceTitle,
lineCode,
});

if (
!repayResultPageTag &&
["wechat", "alipay"].includes(this.payMethod)
) {
const returnUrl = this.repayInitData.returnUrl;

this.sendRecord("1050", getStorage("session", "repayTradeId"));
this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_1050",
tgt_name: "h5-paycash-确认还款页-还款页面跳转外部url",
param4: getStorage("session", "repayTradeId"),
});

if (isKoo) {
location.href = `${returnUrl}${returnUrl.indexOf("?") !== -1 ? "&" : "?"
}status=1&message=成功${isKoo ? "&amount=" + this.actualAmount : ""
}`;
} else if (this.isLoanApp) {
let routeName = "status";
this.$router.push({
name: routeName,
query: {
type: "repay-processing",
orderNo: this.orderNo,
returnUrl: this.repayInitData.returnUrl,
},
});
} else {
const params = {
tradeID: getStorage("session", "repayTradeId"),
interestFreeCoupon,
holidayAmount,
redPacketAmount: this.redPacketAmount,
goldenDiscount:
vipVo && this.isChooseGold === "y"
? vipVo.payBackAmount
: 0,
svipOutPrice: vipVo ? vipVo.svipOutPrice : 0,
};

location.href = `${returnUrl}${returnUrl.indexOf("?") !== -1 ? "&" : "?"
}status=1${"&" + querystring.stringify(params)}`;
}
} else {
let routeName = "status";
if (
this.isPreMultiRepay &&
modelTag === 2 &&
this.period === maxPeriod
) {
routeName = "result";
}
this.$router.push({
name: routeName,
query: {
type: ["wechat", "alipay"].includes(this.payMethod)
? "repay-success"
: "repay-processing",
orderNo: this.orderNo,
returnUrl: this.repayInitData.returnUrl,
},
});
}
},
clearTimer() {
if (
this.sourceId == 2 &&
this.payMethod == "alipay" &&
(this.isLoanApp || this.isKooApp)
) {
this.inQueryResult = false;
}
clearInterval(this.queryTimer);
clearTimeout(this.timer);
},
repayProcessing() {
if (
this.sourceId == 2 &&
this.payMethod == "alipay" &&
(this.isLoanApp || this.isKooApp)
) {
if (this.inQueryResult) return;
this.inQueryResult = true;
}

return new Promise(async (resolve) => {
const seconds = this.repayInitData.pollingSeconds
? this.repayInitData.pollingSeconds * 1000
: 3000;
this.queryRepayResult(resolve);
this.timer = setTimeout(() => {
this.clearTimer();
if (this.statusCode != 1) {
resolve();
}
}, seconds);
this.queryTimer = setInterval(async () => {
this.queryRepayResult(resolve);
}, 1000);
});
},
async queryRepayResult(resolve) {
const repayTradeId = getStorage("session", "repayTradeId");

const data = await this.doRequest("repayQuery", {
tradeID: repayTradeId,
orderType: this.repayInitData.orderType,
});
this.statusCode = data.statusCode;
if (data.statusCode === 1) {
this.sendRecord("1053", repayTradeId);
this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_1053",
tgt_name:
"h5-paycash-确认还款页-还款页面轮询拿到成功结果跳转",
param4: repayTradeId,
});
this.clearTimer();
this.jumpToResultPage();
resolve();
}
},
async repayApply(patchParams) {
if (patchParams) {
this.$vux.loading.show();
}

let payType = 2;
if (this.payMethod === "alipay") {
payType = 6;
} else if (this.isLoanApp || this.isKooApp) {
payType = 1;
} else if (isWeixin() && !this.isWxMiniProgram) {
payType = 3;
} else if (this.isWxMiniProgram) {
payType = 4;
} else {
payType = 2;
}


const appType =
(this.isLoanApp && BuildVersionDiff("10.1.0")) ||
(this.isKooApp && lasterVersion("4.7.0"))
? 1
: null;

const params = Object.assign(this.getBasicReqParams(), {
smsCode: this.isBill ? "" : this.verCode,
smsToken: this.isBill ? "" : this.smsToken,
userBankAccountId: this.bankInfo.userBankAccountId,
paymentMethod: this.paymentMethod,
inputAmount: this.actualAmount,
appSourceType: this.isKooApp ? 2 : 1,
payType: payType,
wxOpenId: this.wxOpenId,
vipOpenTag: this.isChooseGold === "y",
offAmount: this.repayInitData.offAmount,
wxClientIp: this.isWxMiniProgram ? this.wxClientIp : "",
smsType: this.smsType,
appType: appType,
appSystem: this.getAppSystem(),
tenantId: this.tenantId,
});
if (this.isPreMultiRepay) {
Object.assign(params, { multiPeriod: this.period });
}


if (patchParams && patchParams.repayApplyType === 2) {
Object.assign(params, patchParams);
} else if (

this.payMethod === "card" &&
this.bankInfo &&
this.bankInfo.isSplit === 1
) {
const {
singleLimit,
userBankAccountId,
bankID,
bankName,
cardNum,
} = this.bankInfo;

Object.assign(params, {
bankAccountPayInfo: [
{
detailAmount: parseFloat(this.actualAmount),
limitAmount: singleLimit,
userBankAccountId,
bankId: bankID,
bankName,
cardNum,
},
],
repayApplyType: 1,
});
}

this.sendRecord("662");
this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_662",
tgt_name: "h5-paycash-确认还款页-repayApply",
param4: params.appType,
param5: params.appSystem,
param6: params.tenantId,
param7: params.repayApplyType,
});

const { data, result } = await this.$http.repayApply(params);

if (patchParams) {
this.$vux.loading.hide();
}

if (result === SUCCESS_CODE) {
setStorage("session", "repayTradeId", data.tradeID);
setStorage("session", "businessId", data.businessId);

this.sendRecord("661", data.tradeID);
this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_661",
tgt_name: "h5-paycash-确认还款页-还款订单号",
param4: data.tradeID,
param5: data.sdkType,
});
this.thirdChannel = data.thirdChannel; 

if (this.isChooseGold === "y") {
this.sendRecord("619", data.tradeID);
this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_619",
tgt_name:
"h5-paycash-确认还款页-拍金卡-开通还款tradeId",
param4: data.tradeID,
param5: this.repayPage,
});
}

if (
this.repayInitData.splitCount > 1 &&
this.payMethod === "card"
) {

this.showAlert = true;
this.isBtnDisabled = false;
return;
}

if (
this.sourceId == 2 &&
this.payMethod == "alipay" &&
(this.isLoanApp || this.isKooApp)
) {
this.inQueryResult = false;
}

await new Promise((resolve) => {
this.resolve = resolve;
this.sendRecord("1060", this.payMethod);
this.sendRecord("1061", this.isLoanApp);
this.sendRecord("1062", this.isMountListener);

this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_1060_1061_1062",
tgt_name: "h5-paycash-确认还款页-1060-1061-1062",
param4: this.payMethod,
param5: this.isLoanApp,
param6: this.isMountListener,
});

if (
["wechat", "alipay"].includes(this.payMethod) &&
(this.isLoanApp ||
(this.isKooApp && this.payMethod == "alipay")) &&
!this.isMountListener
) {

const repayTradeId = getStorage("session", "repayTradeId");

this.isMountListener = true;
this.sendRecord(
"1059",
repayTradeId
);
this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_1059",
tgt_name:
"h5-paycash-确认还款页-微信支付宝回调监听前",
param4: repayTradeId,
});

const queryResult = async () => {

this.sendRecord(
"1055",
repayTradeId
);
this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_1055",
tgt_name: "h5-paycash-确认还款页-准备轮询结果",
param4: repayTradeId,
});
if (this.isLoanApp) {
if (!getStorage("session", "repayTradeId") && repayTradeId) {
setStorage(
"session",
"repayTradeId",
repayTradeId
);
}
this.isMountListener = false;
window.PPDWebUI.ListenerService.removeResumeListener(
queryResult
);
}
await this.repayProcessing();
this.resolve();
};

if (this.isLoanApp) {
PPDWebUI.ListenerService.resumeListener(
queryResult
);
} else if (this.isKooApp) {
window.resumeListener = queryResult;
}
}

if (this.payMethod === "wechat") {
if (isWeixin() && !this.isWxMiniProgram) {
WeixinJSBridge.invoke(
"getBrandWCPayRequest",
JSON.parse(data.wechatPayInfo),
async (res) => {
if (
res.err_msg ===
"get_brand_wcpay_request:ok"
) {
await this.wechatSuccessCallBack();
this.jumpToResultPage();
} else {
this.showWechatError("支付失败");
}
resolve();
}
);
}

if (this.isLoanApp) {
let wxPayName = "";
let wxPayParams = null;

if (data.sdkType === 1) {

if (
!PPDWebUI.PayService ||
!PPDWebUI.PayService.wxPayV2
) {
PPDWebUI.registerNewService(
"PayService",
"wxPayV2"
);
}

wxPayName = "wxPayV2";
wxPayParams = JSON.parse(
JSON.parse(data.wechatPayInfo).authCode
);
} else {

if (
!PPDWebUI.PayService ||
!PPDWebUI.PayService.wxPay
) {
PPDWebUI.registerNewService(
"PayService",
"wxPay"
);
}

wxPayName = "wxPay";
wxPayParams = { authCode: data.wechatPayInfo };
}


const repayTradeId = getStorage(
"session",
"repayTradeId"
);

this.sendRecord("1054", repayTradeId);
this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_1054",
tgt_name: "h5-paycash-确认还款页-准备唤起微信",
param4: repayTradeId,
param5: wxPayName,
param6: JSON.stringify(wxPayParams),
});

PPDWebUI.PayService[wxPayName](
wxPayParams,
async (data) => {
this.sendRecord("1058", data.status);
this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_1058",
tgt_name:
"h5-paycash-确认还款页-微信回调结果参数",
param4: JSON.stringify(data),
});

if (
(wxPayName == "wxPayV2" &&
data.errCode == "0") ||
(wxPayName == "wxPay" &&
data.status === "20")
) {
if (
!getStorage(
"session",
"repayTradeId"
) &&
repayTradeId
) {
setStorage(
"session",
"repayTradeId",
repayTradeId
);
}
this.sendRecord(
"1052",
getStorage(
"session",
"repayTradeId"
)
);
this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_1052",
tgt_name:
"h5-paycash-确认还款页-跳转微信回调回来跳转",
param4: getStorage(
"session",
"repayTradeId"
),
});
await this.wechatSuccessCallBack();
this.jumpToResultPage();
} else {
this.sendRecord(
"1056",
getStorage(
"session",
"repayTradeId"
)
);
this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_1056",
tgt_name:
"h5-paycash-确认还款页-微信回调支付失败",
param4: getStorage(
"session",
"repayTradeId"
),
});
this.showWechatError("支付失败");
}
resolve();
},
(e) => {
this.sendRecord(
"1057",
getStorage("session", "repayTradeId")
);
this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_1057",
tgt_name:
"h5-paycash-确认还款页-微信唤起失败",
param4: getStorage(
"session",
"repayTradeId"
),
});
this.showWechatError(e.message);
resolve();
}
);
}

if (this.isKooApp) {
let wxPayParams = null;
if (data.sdkType === 1) {
wxPayParams = Object.assign(
JSON.parse(
JSON.parse(data.wechatPayInfo).authCode
),
{
channelName: "wePay",
appId: "",
}
);
} else {
wxPayParams = {
channelName: "weiXin",
appId: "",
authCode: data.wechatPayInfo,
};
}

const params = JSON.stringify({
method: "pay",
data: wxPayParams,
});

this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_1054",
tgt_name: "h5-paycash-确认还款页-准备唤起微信",
param4: getStorage("session", "repayTradeId"),
param5: params,
});
if (navigator.userAgent.includes("iPhone")) {
window.webkit.messageHandlers.XYPay.postMessage(
params
);
} else {
window.XYPayAndroid.exec(params);
}

window.onXYPayResult = async (data) => {
this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_koo_wxpay_result",
tgt_name:
"h5-paycash-确认还款页-Koo微信回调结果参数",
param4: JSON.stringify(data),
});
const { resultCode, channelName } =
JSON.parse(data);
if (channelName === "wePay") {
if (resultCode == "0") {
await this.wechatSuccessCallBack();
this.jumpToResultPage();
} else {
this.showWechatError("支付失败");
}
} else {
if (resultCode === "20") {
await this.wechatSuccessCallBack();
this.jumpToResultPage();
}
if (resultCode === "30") {
this.showWechatError("支付失败");
}
if (resultCode === "-4") {
this.showWechatError("未安装微信");
}

if (resultCode === "-3") {
await this.queryRepayResult();
}
}
resolve();
};
}

if (this.isWxMiniProgram) {
navigateTo(
"/pages/repay/wxPayment",
this.getMiniProgramParams(data)
);
}
} else if (this.payMethod === "alipay") {
const info = JSON.parse(data.wechatPayInfo);

if (this.isLoanApp) {
let payName =
this.thirdChannel == "ALIPAY"
? "aliPayV2"
: "aliPay";

if (
!PPDWebUI.PayService ||
!PPDWebUI.PayService.aliPay ||
!PPDWebUI.PayService.aliPayV2
) {
PPDWebUI.registerNewService(
"PayService",
payName
);
}


const repayTradeId = getStorage(
"session",
"repayTradeId"
);

this.sendRecord("1063", repayTradeId);
this.sendRecord("1064", payName);

this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_1063_1064",
tgt_name:
"h5-paycash-确认还款页-唤起支付宝方法名",
param4: repayTradeId,
param5: payName,
});

PPDWebUI.PayService[payName](
{ authCode: info.authCode },
async (data) => {
this.sendRecord("1065", data.resultStatus);
this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_1065",
tgt_name:
"h5-paycash-确认还款页-支付宝回调状态参数",
param4: data.resultStatus,
});
if (data.resultStatus === "9000") {
await this.wechatSuccessCallBack();
if (
!getStorage(
"session",
"repayTradeId"
) &&
repayTradeId
) {
setStorage(
"session",
"repayTradeId",
repayTradeId
);
}
this.sendRecord(
"1066",
getStorage(
"session",
"repayTradeId"
)
);
this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_1066",
tgt_name:
"h5-paycash-确认还款页-支付宝成功回调",
param4: getStorage(
"session",
"repayTradeId"
),
});
this.jumpToResultPage();
} else {
this.showWechatError("支付失败");
}
resolve();
},
(e) => {
this.showWechatError(e.message);
resolve();
}
);
}

if (this.isKooApp) {
this.sendRecord(
"1063",
getStorage("session", "repayTradeId")
);
this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_1063",
tgt_name:
"h5-paycash-确认还款页-准备唤起支付宝支付",
param4: getStorage("session", "repayTradeId"),
});

const params = JSON.stringify({
authCode: info.authCode,
});
if (navigator.userAgent.includes("iPhone")) {
window.webkit.messageHandlers.Alipay.postMessage(
params
);
} else {
window.AliPayAndroid.exec(params);
}

window.onAliPayResult = async (data) => {
const { resultStatus, resultMsg } =
JSON.parse(data);
this.sendRecord("1065", resultStatus);
this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_1065",
tgt_name:
"h5-paycash-确认还款页-支付宝回调状态参数",
param4: resultStatus,
});
if (resultStatus === "9000") {
await this.wechatSuccessCallBack();
this.sendRecord(
"1066",
getStorage("session", "repayTradeId")
);
this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_1066",
tgt_name:
"h5-paycash-确认还款页-支付宝成功回调",
param4: getStorage(
"session",
"repayTradeId"
),
});
this.jumpToResultPage();
} else {
this.showWechatError("支付失败");
}
resolve();
};
}
} else {
this.jumpToResultPage();
resolve();
}
});
}
this.isBtnDisabled = false;
},
showWechatError(message) {
this.$vux.toast.show({
type: "text",
text: message,
width: "50%",
});
},

async bankRepayApply(isMultiSendCode) {
const { tradeId, orderNo } = this.$route.query;
if (tradeId && !this.isBill && this.signStatusCode == 200) {
return this.repayApply();
}
const { data, result } = await this.sendVertificationCode();
if (result === SUCCESS_CODE) {
const {
redirectUrl,
redirectToken,
needSms,
mobile,
smsToken,
smsType,
} = data;

this.smsType = smsType;
if (needSms) {
this.smsToken = smsToken;
this.mobile = mobile;

if (this.isCMBSigning) {
const bizType = getEnv();

if (redirectUrl) {
if (
bizType == "LoanMiniprogram" ||
bizType == "KooMiniprogram" ||
bizType == "TTMiniprogram"
) {
return this.showWechatError(
"暂不支持该银行，请换卡重试"
);
} else {

this.formData.action = redirectUrl;
this.formData.params =
getFormData(redirectToken);
this.$nextTick(() => {










this.$refs.submitBtn.click();
});
}
} else {
this.isVertificationCodeShow = true;
}
} else {
this.isVertificationCodeShow = true;
}


} else {
this.smsToken = "";
await this.repayApply();
}
} else {
this.isBtnDisabled = false;
}
},
async nextStep() {

if (this.isLoanApp && this.repayInitData.currPayoffDiscountAmount > 0 && !this.showEarlySettleRetentionDialog) {
return this.showEarlySettleRetentionDialog = true;
}


if (this.bizCode == 105 && !this.checkRepaySuppoprtMethods())
return;

this.sensorsRecord("h5_clk", {
tgt_event_id: "h5_paycash_repayconfirm_button",
tgt_name: "h5-paycash-还款确认页-确认还款按钮",
url: location.href,
page: "还款-确认还款页",
param4: this.payMethod,
});

if (this.payMethod === "offlinePay") {
if (this.repayInitData.paymentMethods.includes(0)) {
this.offlineRepay();
} else {
this.showWechatError("暂不支持线下还款");
}
return;
}

if (this.isKooApp && this.payMethod === "friendPay") {
this.friendPay();
return;
}

this.sendRecord("660");

if (this.isChooseGold === "y") {
this.sendRecord("616");
this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_616",
tgt_name: "h5-paycash-确认还款页-拍金卡-选择购买会员",
param4: this.repayPage,
});
}
this.showTheLoading(async () => {
this.isBtnDisabled = true;

let paymentMethod = 2;

if (this.payMethod === "wechat") {
paymentMethod = 3;
}

if (this.payMethod === "alipay") {
paymentMethod = 7;
}

this.paymentMethod = paymentMethod;


await this.bankRepayApply();























});
},
authorize(wxAppId) {
location.replace(
`${location.protocol
}//wechat.ppdai.com/oauth/authbase/${wxAppId}?redirectUrl=${encodeURIComponent(
location.href.replace("repay", "repay/")
)}`
);
},
wechatSuccessCallBack() {
!this.isBill &&
this.$http.wechatSuccessCallBack({
tradeID: getStorage("session", "repayTradeId"),
});
},
async checkAppInstalled(packageName) {
this.sendRecord("1069", getStorage("session", "repayTradeId"));
this.sendRecord("1067", packageName);

this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_1067_1069",
tgt_name: "判断app是否安装参数packageName",
param4: packageName,
param5: getStorage("session", "repayTradeId"),
});

return new Promise((resolve, reject) => {
window.PPDWebUI.AppLinkService.checkInstalled(
{
packageName,
},
(result) => {
this.sendRecord("1068", result);
this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_1068",
tgt_name:
"h5-paycash-确认还款页-判断app是否安装回调结果result",
param4: result,
});
if (result === "1") {
resolve(true);
} else {
resolve(false);
}
},
(e) => {
this.$vux.toast.show({
type: "text",
text: "调用sdk报错了",
width: "50%",
});
reject();
}
);
});
},
async repayLoad() {
this.isLoading = true;
this.$vux.loading.show();
const { result, data } = await this.$http.repayLoad(this.orderNo);

if (result === SUCCESS_CODE) {
if (data.paymentMethods.includes(6)) {
if (isWeixin() && !isWxMiniProgram()) {
const code = this.$route.query.code;
if (!code) {
this.authorize(data.wxAppId);
return;
} else {
try {
const resultData = await this.$http.openAuth({
authCode: code,
orderNum: this.orderNo,
});
if (
resultData &&
resultData.data &&
resultData.data.wxOpenId
) {
this.wxOpenId = resultData.data.wxOpenId;
this.isSupportWechat = true;
}
} catch (e) {
console.log(e);
}
}
}
}

if (data.paymentMethods.includes(8)) {
if (this.isWxMiniProgram) {
try {
const resultData = await this.$http.openAuth({
authCode: getCookie("weChatToken"),
orderNum: this.orderNo,
wxType: 1,
});
if (
resultData &&
resultData.data &&
resultData.data.wxOpenId
) {
this.wxOpenId = resultData.data.wxOpenId;
this.isSupportWechat = true;
}
} catch (e) {
console.log(e);
}
}
}

this.repayInitData = data;

const {
themeType,
bankCardList,
showOffline,
sourceTitle,
listingId,
loanId,
repaymentType,
redEnvelopes,
isXW,
isdraw,
amount,
repayAmount,
originalAmount,
preMultiRepay,
otherRepayTag,
upAmount,
vipVo,
resultThemeSwitch,
growthCouponVos,
zfbActive,
zfbActiveContent,
repayPage,
repayShowInterestFee,
repayShowPrincipal,
paymentMethods,
rejectRepayMessage,
isZfbFirst,
tenantId,
isCombinedRepay,
currPayoffDiscountAmount,
memberRetention
} = data;


if (rejectRepayMessage) {
this.rejectRepayMessage = rejectRepayMessage;
this.showRejectRepayDialog = true;
}


this.repayInitData.isFeeTouMing =
repayShowInterestFee > 0 || repayShowPrincipal > 0;

if (vipVo) {
this.sendRecord("615");
this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_615",
tgt_name: "h5-paycash-确认还款页-拍金卡-是否推荐会员",
param4: repayPage,
param5: vipVo.svipType,
});

this.svipType = vipVo.svipType;
this.svipTypeName = vipVo.svipTypeName;
}
this.isShowOtherRepay = !isWeixin() && otherRepayTag;
this.isPreMultiRepay = repaymentType === 3 && !this.isBill;
this.preMultiRepay = preMultiRepay || {};
this.isPreMultiRepay && (this.period = preMultiRepay.maxPeriod);
this.vipVo = vipVo;

this.actualAmount = upAmount;

this.combinedRepayAmount = upAmount;

this.resultThemeSwitch = resultThemeSwitch;
this.themeType = getThemeByType(themeType || "0");
this.repayPage = repayPage;
this.isZfbFirst = isZfbFirst;

this.tenantId = tenantId;
this.showCombinedRepay = isCombinedRepay === 1;


this.showEarlySettleRetention = currPayoffDiscountAmount > 0 && this.isLoanApp;


this.isShowVipMemberRetention = vipVo && memberRetention && this.isLoanApp && !this.showEarlySettleRetention;

this.sendRecord("620", repaymentType);
this.sendRecord("611", listingId);
this.sendRecord("612", loanId);

this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_syt_611_612_620",
tgt_name: "h5-paycash-确认还款页-611-612-620",
param4: listingId,
param5: loanId,
param6: repaymentType,
param7: repayShowInterestFee,
param8: repayShowPrincipal,
param9: isZfbFirst,
param10: this.tenantId,
param11: isCombinedRepay,
param12: this.showEarlySettleRetention,
param13: vipVo && memberRetention,
});

if (growthCouponVos && growthCouponVos.length > 0) {
this.$bus.$on("repay-load", ({ canRepayLoad }) => {
if (canRepayLoad) {
this.repayLoad();
}
});

setStorage("session", "growthCouponVos", growthCouponVos);
} else {
setStorage("session", "growthCouponVos", []);
}

if (redEnvelopes && redEnvelopes.length) {
setStorage("session", "redEnvelopes", redEnvelopes);


if (!(growthCouponVos && growthCouponVos.length > 0)) {
setStorage("session", "redPacketInfo", redEnvelopes[0]);
this.getRedPacketAmount();
}
} else {
setStorage("session", "redEnvelopes", []);
setStorage("session", "redPacketInfo", {
amount: "",
code: "",
});
}



if (bankCardList && bankCardList.length > 0) {
this.bankInfo = bankCardList[0];
}

this.currentChoosedCard = this.bankInfo.userBankAccountId;

this.isOfflineRepayBtnShow = showOffline;

if (zfbActive) {
this.aliPayTags.zfbActive = zfbActive;
this.aliPayTags.zfbActiveContent = zfbActiveContent;
}


if (this.isKooApp && paymentMethods.includes(7)) {
this.checkKooAlipayInstalled();
} else if (this.bizCode == 105) {
this.checkRepaySuppoprtMethods();
}


const { tradeId } = this.$route.query;
if (tradeId) {
this.getSignPageInit();


this.signProcessing();
}
if (this.isShowVipMemberRetention) {
this.openGoldenCardSetNavigation();
}

this.$bus.$emit("update-title", {
hasHeader: sourceTitle,
});
}
this.$vux.loading.hide();
this.isLoading = false;
},
getMiniProgramParams(data) {
const {
failChangeCard,
repayResultPageTag,
repayADUrl,
orderType,
weChatUrl,
multiCard,
processingSeconds,
interestFreeCoupon,
holidayAmount,
vipVo,
upAmount,
billId,
sourceTitle,
returnUrl,
lineCode,
} = this.repayInitData;

const { rewardAmount } = this.preMultiRepay;

const isKoo = this.bizCode === "105";

let info = {};
try {
info = JSON.parse(data.wechatPayInfo);
} catch (e) {
info = {};
}

const params = {
amount: this.actualAmount,
redirectUrl:
location.protocol + "//" + "paycash.ppdai.com/status",
authCode: info.authCode,
orderNo: this.orderNo,
returnUrl,

extrainfo: JSON.stringify({
isShowChangeCard: failChangeCard,
repayAmount: this.actualAmount,
userBankAccountId: this.bankInfo.userBankAccountId,
isShowResult: repayResultPageTag,
repayADUrl: repayADUrl,
orderType: orderType,
themeType: this.themeType,
weChatUrl,
multiCard,
processingSeconds,
isKoo,
isPreMultiRepay: this.isPreMultiRepay,
rewardAmount,
payMethod: this.payMethod,
resultThemeSwitch: this.resultThemeSwitch,
cashbackInfo: {
interestFreeCoupon,
holidayAmount,
redPacketAmount: this.redPacketAmount,
goldenDiscount:
vipVo && this.isChooseGold === "y"
? vipVo.payBackAmount
: 0,
svipOutPrice: vipVo ? vipVo.svipOutPrice : 0,
},
billId,
sourceTitle,
tradeID: data.tradeID,
businessId: data.businessId,
lineCode,
}),
};

this.sensorsRecordRepay({
tgt_event_id: "h5_paycash_repay_miniprogram",
tgt_name: "h5-paycash-确认还款页-微信小程序还款",
param4: params.redirectUrl,
});

return params;
},
judgeSupportedPayMethod(payMethod) {
const paymentMethods = this.repayInitData.paymentMethods;
return paymentMethods && paymentMethods.includes(payMethod);
},
sensorsRecordRepay(recordParam) {
try {
const _params = Object.assign(
{
tgt_event_id: "",
tgt_name: "",
url: location.href,
page: "还款-确认还款页",
},
recordParam
);
this.sensorsRecord("h5_element_imp", _params);
} catch (e) {
console.log(e);
}
},
signProcessing() {

this.querySignResult();
this.signTimer = setTimeout(() => {
this.clearSignTimer();

if (this.statusCode == 200) {
this.repayApply();
}
if (this.statusCode == 201) {
this.showWechatError(this.signStatusMsg);
}
}, 10000);
this.querySignTimer = setInterval(async () => {
this.querySignResult();
}, 3000);
},

async querySignResult() {

this.loadingTimer = setTimeout(() => {
this.$vux.loading.show();
clearTimeout(this.loadingTimer);
}, 0);
const { tradeId, ord } = this.$route.query;
const { data, result } = await this.$http.repaySignConfirm({
tradeID: tradeId,
orderNum: ord,
});

if (result === SUCCESS_CODE) {
const { statusCode, resultMsg } = data;
this.signStatusCode = statusCode;
this.signStatusMsg = resultMsg;

if (statusCode == 200) {
this.clearSignTimer();
this.repayApply();
}

if (statusCode == 201) {
this.clearSignTimer();
this.showWechatError(resultMsg);
}
}
},

clearSignTimer() {
clearInterval(this.querySignTimer);
clearTimeout(this.signTimer);
this.$vux.loading.hide();
},

getSignReturnUrl() {
const { orderNo } = this.$store;

const params = {
ord: orderNo,
u: this.bankInfo.userBankAccountId,

i: this.isChooseGold,
};

if (this.repayInitData.expirePartRepay) {
params.m = this.actualAmount;
}

return (
location.origin + location.pathname + "?" + queryFormat(params)
);
},

getSignPageInit() {
const { u, i, m } = this.$route.query;
this.isChooseGold = i;


if (this.repayInitData.expirePartRepay && m) {
this.actualAmount = m;
}

this.currentChoosedCard = u;
const bankList = this.repayInitData.bankCardList;
const idx = bankList.findIndex(
(item) => item.userBankAccountId === u
);
this.bankInfo = bankList[idx];
},
checkRepaySuppoprtMethods() {
const bankList = this.repayInitData.bankCardList || [];

if (bankList.length <= 0) {
const paymentMethods = this.repayInitData.paymentMethods || [];

const isSupportWechat =
this.isSupportWechat &&
((this.isKooApp && paymentMethods.includes(3)) ||
(isWeixin() && paymentMethods.includes(6)));

const isSupportAlipay =
this.isSupportAlipay && paymentMethods.includes(7);

const isSupportOfflinePay = paymentMethods.includes(0);

const isSupportFriendPay =
paymentMethods.includes(5) &&
this.isKooApp &&
lasterVersion("4.6.0") &&
this.isChooseGold === "n";

if (
!(
isSupportWechat ||
isSupportAlipay ||
isSupportOfflinePay ||
isSupportFriendPay
)
) {

this.showBindCardDialog = true;

this.sensorsRecord("h5_clk", {
tgt_event_id: "h5_paycash_repay_noMethods",
tgt_name: "h5-paycash-还款确认页-没有还款方式",
url: location.href,
page: "还款-确认还款页",
});
return false;
} else {
if (isSupportAlipay) {
this.payMethod = "alipay";
} else if (isSupportWechat) {
this.payMethod = "wechat";
} else if (isSupportOfflinePay) {
this.payMethod = "offlinePay";
} else if (isSupportFriendPay) {
this.payMethod = "friendPay";
}
}
}
return true;
},
checkKooAlipayInstalled() {

const params = {
method: "isInstallApp",
data: {
packageName: ["alipay://"],
},
};

window.onNativeCall = (result) => {
try {
const res = JSON.parse(result);
if (res.method == "isInstallApp") {
this.isSupportAlipay =
lasterVersion("4.0.0") &&
res.data.packageName.length == 1;

this.bizCode == 105 && this.checkRepaySuppoprtMethods();
}
} catch (e) {
console.log(e);
}
};

if (navigator.userAgent.includes("iPhone")) {
window.koosdk.postMessage(JSON.stringify(params));
} else {
params.data.packageName = ["com.eg.android.AlipayGphone"];
window.koosdk.exec(JSON.stringify(params));
}
},
getAppSystem() {
if (this.isLoanApp || this.isKooApp) {
return this.sourceId == 1
? this.isLoanApp
? 1
: 3
: this.isLoanApp
? 2
: 4;
}
return null;
},
combinedRepayApply(data) {
this.repayApply(data);
},
setCombinedRepayAmount(amount) {
this.combinedRepayAmount = amount;
},
earlySettlePreRepay() {
this.nextStep();
},
earlySettleCommonRepay() {

location.href = location.protocol + "//loanrepay.ppdai.com/newapp/latest/index.html?needAuth=true#/simpleRepayList"
},
joinOpenGoldCardMember() {
this.showOpenGoldenCardRetentionDialog = false;
this.isChooseGold = 'y';


this.$refs.openGoldenCard.isOpenedGoldCard = true;
},
leaveCurrentPage() {
if (this.closeCurrentPageType === '1') {
PPDWebUI.CommonService.back()
} else {
PPDWebUI.CommonService.close();
}
},
openGoldenCardSetNavigation() {
const that = this;
const params = {
visible: '1',
fullScreen: '2',
separatorLine: "1",
leftView: [
{
action: 'back',
icon: 'ppdwebui://resource/drawable/nav_back',
callback: function () {
that.closeCurrentPageType = '1';
that.showOpenGoldenCardRetentionDialog = true;

that.sensorsRecord("h5_clk", {
tgt_event_id: "h5_paycash_leave_currentpage_type",
tgt_name: "h5-paycash-还款确认页-离开当前页面方式",
url: location.href,
page: "还款-确认还款页",
param4: that.closeCurrentPageType,
param5: that.showOpenGoldenCardRetentionDialog,
});
}
},
{
action: 'close',
icon: 'ppdwebui://resource/drawable/nav_close',
callback: function () {
that.closeCurrentPageType = '2';
that.showOpenGoldenCardRetentionDialog = true;

that.sensorsRecord("h5_clk", {
tgt_event_id: "h5_paycash_leave_currentpage_type",
tgt_name: "h5-paycash-还款确认页-离开当前页面方式",
url: location.href,
page: "还款-确认还款页",
param4: that.closeCurrentPageType,
param5: that.showOpenGoldenCardRetentionDialog,
});
}
}
],
}

setNavigation(params);
}
},
async created() {
loadFont();
this.isTarsInWX =
location.origin.includes("paifenle.com") && isWeixin();

if (this.isTarsInWX && window.history && window.history.pushState) {
window.history.pushState(null, "", "#");
window.addEventListener("popstate", this.popstateFunc);
}

const { appId, bizCode, orderNo, businessID } = this.$store;

const { system } = getAppInfo();
this.sourceId = system === "ios" ? 1 : 2;

this.orderNo = orderNo;
this.bizCode = bizCode;
this.sendRecord("600", bizCode);
this.sendRecord("610", appId);
this.sendRecord("613", businessID);
Sensors.login(orderNo);

this.isLoanApp =
window.PPDWebUI &&
window.PPDWebUI.os.inApp &&
window.PPDWebUI.os.channel === "PPDLoanApp";

this.isKooApp =
window.XYPayAndroid ||
(window.webkit &&
window.webkit.messageHandlers &&
window.webkit.messageHandlers.XYPay);

this.isWxMiniProgram = isWxMiniProgram();

if (this.isLoanApp) {
const [version, firstVer, secondVer, thirdVer] =
PPDWebUI.os.buildVersion.match(/(\d+)\.(\d+)\.(\d+)/);

this.isSupportWechat =
parseInt(
firstVer +
secondVer.padStart(2, "0") +
thirdVer.padStart(2, "0")
) >= 71600;


this.isSupportAlipay =
parseInt(
firstVer +
secondVer.padStart(2, "0") +
thirdVer.padStart(2, "0")
) >= 90400;


if (this.isSupportAlipay) {
let packageName =
system === "android"
? "com.eg.android.AlipayGphone"
: "alipay://";
this.isSupportAlipay = await this.checkAppInstalled(
packageName
);
}
}

if (this.isKooApp) {
this.isSupportWechat = true;
}

this.sensorsRecord("h5_element_imp", {
tgt_event_id: "h5_paycash_repayconfirm_pageview",
tgt_name: "h5-paycash-还款确认页-页面曝光",
url: location.href,
page: "还款-确认还款页",
});

this.repayLoad();
},
mounted() {

































if (this.isWxMiniProgram) {
getIp().then((res) => {
this.wxClientIp = res.cip;
});
}

addWhiteList();
},
beforeRouteLeave(to, from, next) {
if (this.isShowVipMemberRetention) {
const navParams = {
fullScreen: "2", // 全屏
visible: "1",
bgColor: "#FFFFFF",
separatorLine: "1", //1显示，2不显示   默认显示
leftView: [
{
action: "back",
icon: "ppdwebui://resource/drawable/nav_back",
},
{
action: "close",
icon: "ppdwebui://resource/drawable/nav_close",
},
],
titleView: {
text: "",
},
};
setNavigation(navParams);
}

next();
},
beforeDestroy() {
if (this.isTarsInWX && window.history && window.history.pushState) {
window.removeEventListener("popstate", this.popstateFunc);
}
this.$bus.$off(["repay-load"]);
},
};
